import React, { useEffect, useState } from "react";
import { Link } from "@reach/router";
import useGame from "../../hooks/useGame";
import styled from "styled-components";
import {
  ShowGameContainer,
  MenuContainer
} from "../../styled_components/containers";
import RatingStats from "../../hooks/useRatingStats";
import Rankings from "../../hooks/useRankings";
import ReactTooltip from 'react-tooltip';
import { Scale } from 'react-scaling';

import { navigate } from "@reach/router";//this is for the back button

export default function GameMenu({ id, ...props }) {
  const game = useGame(id);
  var imagebg = require('../../assets/' + game.selection_background);
  var ratings = RatingStats();
  var rank;
  if (game.game_type == "multiplication") {
    rank = Rankings({ service_key: "timetables" });
  } else {
    rank = Rankings({ service_key: game.game_type });
  }

  const [myRating, setMyRating] = useState(0);

  useEffect(() => {
    if (ratings !== undefined) {
      console.log(ratings);
      console.log(GetRating(id));
      setMyRating(GetRating(id));
    }
    if (rank != undefined) {
      console.log(rank);
    }
  }, [ratings]);

  useEffect(() => {
    if (rank !== undefined) {
      console.log(rank);
    }
  }, [rank]);

  function GetRating(id) {
    var myrate = -1;
    for (let i = 0; i < ratings.length; i++) {
      if (ratings[i].service_id == id) {
        console.log(ratings[i]);
        myrate = ratings[i].rating;
      }
    }
    console.log(myrate);
    //fiddle with it
    myrate = Math.round(myrate / 150);
    return myrate;
  }
  if (rank == undefined){
    return <div></div>
  }

  if (id == 22) {
    return (

      <ShowGameContainer style={{ backgroundImage: `url(${imagebg})` }}>
        <Scale scaleTo={1420}>
          <h1 Style="color:#673c8c; text-align:center">{game && game.description}</h1>
          <Buttonz onClick={() =>{navigate("/games")}}>Back</Buttonz>
          <MenuContainer
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between"
            }}
          >
            <StyledLink to="rating">Play Multiplication Table Check</StyledLink>
            <StyledLink to="MTCpractise">Practise</StyledLink>

          </MenuContainer>
        </Scale>
      </ShowGameContainer>

    );
  }
  else if (id == 38){
    return (

      <ShowGameContainer style={{ backgroundImage: `url(${imagebg})` }}>
        <Scale scaleTo={1420}>
          <h1 Style="color:white; text-align:center">{game && game.description}</h1>
          <Buttonz onClick={() =>{navigate("/games")}}>Back</Buttonz>
          <MenuContainer
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between"
            }}
          >
            <StyledLink to="rating">Play</StyledLink>
            <StyledLink to="SpellingSATsPractice">Practise</StyledLink>

          </MenuContainer>
        </Scale>
      </ShowGameContainer>

    );
  }
  else if (id == 39){
    return (

      <ShowGameContainer style={{ backgroundImage: `url(${imagebg})` }}>
        <Scale scaleTo={1420}>
          <h1 Style="color:white; text-align:center">{game && game.description}</h1>
          <Buttonz onClick={() =>{navigate("/games")}}>Back</Buttonz>
          <MenuContainer
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between"
            }}
          >
            <StyledLink to="rating">Play</StyledLink>
            <StyledLink to="KS1Practice">Practise</StyledLink>

          </MenuContainer>
        </Scale>
      </ShowGameContainer>

    );
  }
  else if (id == 23) {
    return (

      <ShowGameContainer style={{ backgroundImage: `url(${imagebg})` }}>
        <Scale scaleTo={1420}>
          <h1 Style="color:#673c8c; text-align:center">{game && game.description}</h1>
          <Buttonz onClick={() =>{navigate("/games")}}>Back</Buttonz>
          <MenuContainer
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between"
            }}
          >
            <StyledLink to="rating">Play Intervention</StyledLink>

          </MenuContainer>
        </Scale>
      </ShowGameContainer>

    );
  } else if (id == 10 || id == 26 || id == 9 || id == 14){
    return (

      <ShowGameContainer style={{ backgroundImage: `url(${imagebg})` }}>
        <Scale scaleTo={1920}>
          <h1 Style="color:#fff; text-align:center">{game && game.description}</h1>
          <Buttonz onClick={() =>{navigate("/games")}}>Back</Buttonz>
          <MenuContainer
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between"
            }}
          >
            <StyledLink to="rating">Rating Game</StyledLink>
            {myRating != null && rank.progress < 10  ? (
              <div>
                <StyledLink to="learn">Learn</StyledLink>
                <StyledLink to="practise">Practise</StyledLink>
                <StyledLink to="multiplayer">Multiplayer</StyledLink>
                <StyledLink to="duels">Duels</StyledLink>
                <StyledLink to="endless">Endless</StyledLink>
                <StoryButton onClick={() =>{navigate("/story")}}>Story Mode</StoryButton>
              </div>

            ) : (
                <div>
                  <Tools />
                  <GreyedButton data-tip="Play a rating game to unlock the other game modes" to="learn">Learn</GreyedButton>
                  <GreyedButton data-tip="Play a rating game to unlock the other game modes" to="practise">Practise</GreyedButton>
                  <GreyedButton data-tip="Play a rating game to unlock the other game modes" to="multiplayer">Multiplayer</GreyedButton>
                  <GreyedButton data-tip="Play a rating game to unlock the other game modes" to="endless">Endless</GreyedButton>
                </div>
              )}
          </MenuContainer>
        </Scale>
      </ShowGameContainer>

    );

  } else {

    return (

      <ShowGameContainer style={{ backgroundImage: `url(${imagebg})` }}>
        <Scale scaleTo={1920}>
          <h1 Style="color:#fff; text-align:center">{game && game.description}</h1>
          <Buttonz onClick={() =>{navigate("/games")}}>Back</Buttonz>
          <MenuContainer
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between"
            }}
          >
            <StyledLink to="rating">Rating Game</StyledLink>
            {myRating != null && rank.progress < 10  ? (
              <div>
                <StyledLink to="practise">Practise</StyledLink>
                <StyledLink to="multiplayer">Multiplayer</StyledLink>
                <StyledLink to="duels">Duels</StyledLink>
                <StyledLink to="endless">Endless</StyledLink>
                <StoryButton onClick={() =>{navigate("/story")}}>Story Mode</StoryButton>
              </div>

            ) : (
                <div>
                  <Tools />
                  <GreyedButton data-tip="Play a rating game to unlock the other game modes" to="practise">Practise</GreyedButton>
                  <GreyedButton data-tip="Play a rating game to unlock the other game modes" to="multiplayer">Multiplayer</GreyedButton>
                  <GreyedButton data-tip="Play a rating game to unlock the other game modes" to="endless">Endless</GreyedButton>
                </div>
              )}
          </MenuContainer>
        </Scale>
      </ShowGameContainer>

    );
  }
}

const Buttonz = styled.button`
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  width: 20%;
  border: 2px solid #e88f12;
  color: #fff;
  user-select: none;
  padding: 0.5em;
  margin: -0.5em 0;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`

const Tools = styled(ReactTooltip)`
  font-size: 20px !important;
  background-color: #543171FF !important;
`

const StyledLink = styled(Link)`
  display: block;
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  width: 100%;
  border: 2px solid #e88f12;
  color: #fff;
  user-select: none;
  padding: 0.5em;
  margin: 15px 0;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  text-decoration: none;
  text-align: center;

  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const StoryButton = styled.button`
display: block;
background: rgb(234, 146, 19);
background: linear-gradient(
  0deg,
  rgba(234, 146, 19, 1) 0%,
  rgba(255, 186, 32, 1) 100%
);
width: 100%;
border: 2px solid #e88f12;
color: #fff;
user-select: none;
padding: 0.5em;
margin: 15px 0;
box-sizing: border-box;
border-radius: 0.25em;
font-size: 3em;
cursor: pointer;
text-decoration: none;
text-align: center;

@media (min-width: 1025px) and (max-width: 1440px) {
  font-size: 2.5em;
}

@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  margin-bottom: 0;
}

a {
  color: #fff;
  text-decoration: none;
  }
}
}
`;

const GreyedButton = styled.button`
  background: rgb(195, 195, 195);
  background: linear-gradient(
    0deg,
    rgb(195, 195, 195) 0%,
    rgb(150, 150, 150) 100%
  );
  width: 100%;
  border: 2px solid #a0a0a0;
  color: #fff;
  user-select: none;
  padding: 0.5em;
  margin: 15px 0;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  text-decoration: none;
  text-align: center;

  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 10px;
  }
`;
